import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { ModalsService } from '@core/modals/modals.service';
import { Seat, SeatDetails } from '@core/models';
import { AvailabilityService, DvmService } from '@core/services';
import { SeatManagementService } from '@features/digital-venue/services/seat-management.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-seat-item',
  templateUrl: './cart-seat-item.component.html',
  styleUrl: './cart-seat-item.component.scss',
})
export class CartSeatItemComponent implements OnDestroy {
  //SERVICES
  private dvmService: DvmService = inject(DvmService);
  private seatManagementService: SeatManagementService = inject(
    SeatManagementService
  );
  private availabilityService: AvailabilityService =
    inject(AvailabilityService);
  private modalService: ModalsService = inject(ModalsService);

  // INPUTS & OUTPUTS
  @Input()
  public data: Seat;

  @Input()
  public showSeats: boolean = false;

  @Input()
  public isTicketFeeEnabled: boolean = false;

  @Input()
  public seatIndex: number;

  @Output()
  public toggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  // PUBLIC COMPONENT METHODS
  public removeSeat(): void {
    const seatData = this.data as Seat;
    this.seatManagementService.unselectSelectedSeats([
      { id: seatData.id, originalId: seatData.original_id },
    ]);
  }

  // DVM METHODS

  public openSeatDefinition(): void {
    if (!this.data) {
      return;
    }
    const seatInfo = this.availabilityService.getSeatByIdFromAvailability(
      this.data.id
    );
    const dvmSeat = this.dvmService.viewerService.getNodeById(this.data.id);

    if (!dvmSeat) {
      return;
    }

    this.modalService.openSeatDefinitionModal(seatInfo, dvmSeat.original_id);
  }

  public open3dView(): void {
    if (!this.data) {
      return;
    }
    this.dvmService.load3dView(this.data.id);
  }

  public getSeatAvailability(): SeatDetails {
    if (!this.data) {
      return {
        isAda: false,
        seatDefinition: [],
      };
    }
    const sectionId: string = this.data.id.split('-')[0];
    const { isAda, seatDefinition } =
      this.availabilityService.seatsAvailability[sectionId][this.data.id];

    return { isAda, seatDefinition };
  }

  // PRIVATE COMPONENT METHODS
  protected hasSeatDefinition(): 'info' | 'adas' | null {
    if (!this.data) {
      return null;
    }
    const seatAvailability: SeatDetails = this.getSeatAvailability();

    if (seatAvailability.seatDefinition.length) {
      return 'info';
    } else if (
      seatAvailability.isAda &&
      !seatAvailability.seatDefinition.length
    ) {
      return 'adas';
    } else {
      return null;
    }
  }
}
